import React from 'react';
import { Redirect } from 'react-router-dom';
import authService from '../../services/authService';
import { useAuthValidation } from '../../hooks/useAuthValidation';

export default function ProtectedRoute({ children, requireAdmin = false }) {
    const { isValidating, isValid } = useAuthValidation();

    // Afficher un loader pendant la validation
    if (isValidating) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh'
            }}>
                <div>Vérification de l'authentification...</div>
            </div>
        );
    }

    // Si pas de token OU token invalide, rediriger vers login
    if (!authService.isAuthenticated() || !isValid) {
        return <Redirect to="/login" />;
    }

    if (requireAdmin) {
        const user = authService.getUser();
        if (!user || !authService.isAdmin()) {
            return (
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh',
                    flexDirection: 'column',
                    gap: '16px'
                }}>
                    <h1>403 - Accès interdit</h1>
                    <p>Vous devez être administrateur pour accéder à cette page</p>
                    <a href="/" style={{ color: 'var(--color-primary)' }}>
                        Retour au tableau de bord
                    </a>
                </div>
            );
        }
    }

    return children;
}
